import React from 'react';

const education = () => {
        return (
            <>
                <div className="education">
                    <h1>EDUCATION</h1>
                    <h4>UPM Malaysia</h4>
                    <p>From 03/2024 --</p>	
                    <p>Software Engineering</p>
                </div>
            </>
        );
    }

export default education;